import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    customLabelStyle: {
      fontSize: '12px !important',
      // @ts-ignore: Unreachable code error
      fontWeight: '700 !important',
      color: '#2C62EC !important',
    },
    stepperRoot: {
      '& .MuiSvgIcon-root': {
        color: '#00BA34',
        fontSize: 18,
      },
      '& .MuiStepConnector-root': {
        background: '#000',
        top: '16px !important',
      },
    },
    iconContainerStyle: {
      display: 'grid!important',
      height: '25px',
      width: '25px',
      background: '#F0F0F0',
      boxShadow: 'inset 0px 4px 4px rgb(0 0 0 / 25%)',
      placeItems: 'center',
      borderRadius: '50%',
    },
  })
);

export default useStyles;
